import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 850px;
  height: calc(100vh - 80px);
  padding: 25px 45px;

  @media (max-width: 768px) {
    padding: 25px 20px 240px;
    height: 100%;
    width: 100%;
  }
`;

export const Title = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 1;
  margin-bottom: 15px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const ContentItem = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  border-radius: 8px;
  text-decoration: none;
  padding: 15px;
  color: ${({ theme }) => theme?.colors?.lightBlue};

  & svg {
    font-size: 25px;
  }

  &:hover {
    color: ${({ theme }) => theme?.colors?.mediumBlue};
  }
`;

export const ContentFirst = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentTitle = styled.span`
  font-size: 18px;
  padding-left: 10px;
`;
